import React from 'react';
import Sidebar from 'components/Sidebar/Sidebar.react';

const settingsSections = [
  {
    name: 'Apps',
    link: '/products/apps',
  },
  // {
  //   name: 'CDN',
  //   link: '/products/cdn',
  // }
];

const accountSections = [
  {
    name: 'Info',
    link: '/account/info',
  },
  {
    name: 'Activity',
    link: '/account/activity',
  },
  {
    name: 'Legal & Compliance',
    link: '/account/legal',
  },
  {
    name: 'Security',
    link: '/account/security',
  },
];


const accountSidebarSections = [
  {
    name: 'Products',
    icon: 'icon-apps',
    link: '/products/apps',
    subsections: settingsSections,
  },
  {
    name: 'Billing',
    icon: 'icon-coins',
    link: '/billing',
  }, {
    name: 'Automatic Database Backups',
    icon: 'icon-db',
    link: '/backups',
  }, {
    name: 'Account',
    icon: 'icon-robot',
    link: '/account/info',
    subsections: accountSections,
  }, {
    name: 'Referrals',
    icon: 'icon-invite-user',
    link: '/referrals',
  },
];


export default function buildAccountSidebar(props) {
  return (
    <Sidebar
      {...props}
      sections={accountSidebarSections}
      section={props.section}
      subsection={props.subsection} />
  );
}
